// Shape listing rows into the `items` array StructuredData's ItemList
// expects ({ name, url, image, price }). Image fields mirror the
// thumbnail conventions in the v1 product/card grids.
import { cardImageUrl } from "./cardImageUrl";
import { singleCardUrl } from "./slugify";

export function productListItems(products = []) {
  return (products || [])
    .filter((p) => p && p.slug && p.title)
    .map((p) => {
      const base = p.thumbnailSyncedToContent
        ? process.env.cdnImageStorage
        : process.env.imageStorage;
      return {
        name: p.title,
        url: `/produs/${p.slug}`,
        image: p.thumbnail ? `${base}/thumb_${p.thumbnail}.jpg` : undefined,
        price: p.price != null ? p.price : undefined,
      };
    });
}

export function cardListItems(cards = []) {
  return (cards || [])
    .filter((c) => c && c.id != null && c.name)
    .map((c) => ({
      name: c.name,
      url: singleCardUrl(c),
      image: c.image ? cardImageUrl(c.image) : undefined,
      price: c.price != null ? c.price : undefined,
    }));
}
